import ChatBody from "components/shared/chat/body";
import DateMessage from "components/shared/chat/body/dateMessage";
import { preformatMessagesParams } from "helpers/chat";
import React from "react";
import SignalRConnection from "services/signalRConnection";
import { getChatMessages, STEP } from "sources/carChats";
import Message from "./message";

export default class ScrollBody extends ChatBody {
    state = {
        shouldUpdate: true,
        skip: 0,
        endReached: false,
        items: [],
        dates: [],
        date: "",
        newMsgCount: 0,
    };

    componentDidMount() {
        const { chatId } = this.props;
        this.connection = new SignalRConnection({
            url: "/signalr/aggregationChatMessages",
            connectionParams: chatId,
            actions: [{ name: "Send", action: (data) => this.applyMessage({ ...data, messageId: data.id }) }],
            joinActionName: "JoinChat",
            leaveActionName: "LeaveChat",
        });

        this.getItems(true);
    }

    componentWillUnmount() {
        if (this.connection) {
            this.connection.disconnect();
        }
    }

    getItems = (first) => {
        const { chatId, onlyMyMessages } = this.props;
        const { items, isLoading, endReached } = this.state;

        if (isLoading || (!first && endReached)) {
            return;
        }

        const params = {
            queryFilter: onlyMyMessages ? { onlyMyMessages } : {},
            filter: { ...(first ? {} : preformatMessagesParams(items)) },
            skip: 0,
            ...(first ? { top: STEP * 2 } : {}),
        };
        this.setState({ shouldUpdate: false, isLoading: true });
        return getChatMessages(params, chatId).then((res) => this.handleRes(res, first));
    };

    renderBody = () => {
        const currentAudio = React.createRef();
        const id = parseInt(this.props.profile.id);
        const changeDate = (date) => this.setState({ date });
        const { items, dates } = this.state;
        return items.map((item, i) => {
            if (item.isDeleted) {
                return null;
            }
            if (item.msgType === "date") {
                return (
                    <DateMessage
                        key={item.text}
                        {...item}
                        changeDate={changeDate}
                        dates={dates}
                        chatBodyRef={this.chatBody}
                    />
                );
            } else {
                const props = {
                    ...item,
                    currentAudio,
                    userId: id,
                    modal: this.props.modal,
                    addModal: this.props.addModal,
                    index: i,
                };
                return <Message key={item.id} {...props} />;
            }
        });
    };
}
